(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var trigger = document.querySelector('[data-editorial-menu-trigger]');
    var panel = document.getElementById('EditorialMenuPanel');
    if (!trigger || !panel) return;

    var drawer = panel.querySelector('.emnav-drawer');
    var editorialMenu = panel.querySelector('[data-editorial-menu]');
    var closeTargets = panel.querySelectorAll('[data-editorial-menu-close]');
    var backButtons = panel.querySelectorAll('[data-editorial-back]');
    var lastFocused = null;
    var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function open() {
      lastFocused = document.activeElement;
      panel.removeAttribute('hidden');
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keyup', onKeyUp);

      var focusable = panel.querySelector('a, button');
      if (focusable) focusable.focus();

      activateDefaultState();
    }

    function close() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keyup', onKeyUp);

      var finished = function () {
        panel.setAttribute('hidden', '');
        resetToNavScreen();
        drawer.removeEventListener('transitionend', finished);
      };
      drawer.addEventListener('transitionend', finished);

      if (lastFocused) lastFocused.focus();
    }

    function onKeyUp(event) {
      if (event.key === 'Escape') close();
    }

    trigger.addEventListener('click', function () {
      panel.classList.contains('is-open') ? close() : open();
    });

    closeTargets.forEach(function (el) {
      el.addEventListener('click', close);
    });

    if (!editorialMenu) return;

    var navLinks = editorialMenu.querySelectorAll('[data-editorial-index]');

    function activateRail(index) {
      var rails = editorialMenu.querySelectorAll('[data-editorial-rail-panel]');
      var target = editorialMenu.querySelector('[data-editorial-rail-panel="' + index + '"]');
      rails.forEach(function (r) { r.setAttribute('hidden', ''); });
      if (target) target.removeAttribute('hidden');
    }

      function activatePanel(index) {
      var target = editorialMenu.querySelector('[data-editorial-panel="' + index + '"]');
      if (target && target.classList.contains('is-visible') && !target.hasAttribute('hidden')) {
        return; // ya está activo, no reiniciamos la animación
      }

      var panels = editorialMenu.querySelectorAll('[data-editorial-panel]');
      var links = editorialMenu.querySelectorAll('[data-editorial-index]');

      panels.forEach(function (p) {
        p.classList.remove('is-visible');
        p.setAttribute('hidden', '');
      });
      links.forEach(function (l) { l.setAttribute('aria-expanded', 'false'); });

      if (!target) return;

      target.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.classList.add('is-visible');
        });
      });

      var activeLink = editorialMenu.querySelector('[data-editorial-index="' + index + '"]');
      if (activeLink) activeLink.setAttribute('aria-expanded', 'true');
    }

    function resetToNavScreen() {
      editorialMenu.classList.remove('menu-drawer__editorial--drilldown');
      var panels = editorialMenu.querySelectorAll('[data-editorial-panel]');
      panels.forEach(function (p) {
        p.classList.remove('is-visible');
        p.setAttribute('hidden', '');
      });
      var links = editorialMenu.querySelectorAll('[data-editorial-index]');
      links.forEach(function (l) { l.setAttribute('aria-expanded', 'false'); });
    }

    function activateDefaultState() {
      var firstRail = editorialMenu.querySelector('[data-editorial-rail-panel]');
      if (firstRail) activateRail(firstRail.getAttribute('data-editorial-rail-panel'));

      if (hasHover) {
        var firstWithPanel = editorialMenu.querySelector('[aria-haspopup="true"]');
        if (firstWithPanel) {
          var idx = firstWithPanel.getAttribute('data-editorial-index');
          activateRail(idx);
          activatePanel(idx);
        }
      }
    }

    navLinks.forEach(function (link) {
      var index = link.getAttribute('data-editorial-index');
      var hasPanel = link.getAttribute('aria-haspopup') === 'true';

      if (!hasPanel) return; // enlace directo, navega normal

      if (hasHover) {
        link.addEventListener('pointerenter', function () {
          activateRail(index);
          activatePanel(index);
        });
      } else {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          activateRail(index);
          activatePanel(index);
          editorialMenu.classList.add('emnav-drilldown');
        });
      }
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        editorialMenu.classList.remove('emnav-drilldown');
      });
    });
  });
})();